/**
 * Configuration for third-party tracking services
 * Centralized management of tracking IDs and settings
 */

export const TRACKING_CONFIG = {
  // Google Services
  gtm: {
    id: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    enabled: !!process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
  },

  // Microsoft Clarity
  clarity: {
    id: 'mxlqzcq49d',
    enabled: true,
  },

  // LinkedIn Insight
  linkedin: {
    partnerId: '5840842',
    enabled: true,
  },

  // Facebook Pixel
  facebook: {
    pixelId: '1100775447281046',
    enabled: true,
  },

  // Other tracking services
  albacross: {
    enabled: true,
    scriptUrl: 'https://serve.albacross.com/track.js',
  },

  apollo: {
    enabled: true,
    scriptUrl:
      'https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=32kfk',
  },

  // HubSpot
  hubspot: {
    portalId: process.env.NEXT_PUBLIC_HS_PLATFORM_ID,
    enabled: !!process.env.NEXT_PUBLIC_HS_PLATFORM_ID,
  },
} as const;

/**
 * Loading delays for different services (in milliseconds)
 * Staggered to prevent simultaneous main thread blocking
 */
export const LOADING_DELAYS = {
  gtm: 500,
  clarity: 2000,
  linkedin: 3000,
  facebook: 4000,
  albacross: 5000,
  apollo: 6000,
} as const;

/**
 * Critical vs non-critical script classification
 */
export const SCRIPT_PRIORITY = {
  critical: ['gtag'], // Google Tag always loads with consent mode
  nonCritical: [
    'gtm',
    'clarity',
    'linkedin',
    'facebook',
    'albacross',
    'apollo',
  ],
} as const;
